import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

import { Tooltip } from "../../base/tooltip";
import styles from "./cell-text-static.module.css";

export function CellTextStatic(props: {
  value: string;
  multiline?: boolean;
  width?: number;
}) {
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!textRef.current) return;
    if (!props.multiline && !props.width) return;
    const el = textRef.current;

    const checkOverflow = () => {
      if (props.multiline) {
        setOverflows(!expanded && el.clientWidth < el.scrollWidth);
      } else if (props.width) {
        setOverflows(el.clientWidth < el.scrollWidth);
      }
    };

    checkOverflow();
    const ro = new ResizeObserver(checkOverflow);
    ro.observe(el);
    return () => ro.disconnect();
  }, [props.multiline, props.width, props.value, expanded]);

  const span = (
    <span
      className={clsx(
        props.multiline && styles.multiline,
        props.multiline && !expanded && styles.collapsed,
        props.width && "block truncate",
      )}
      ref={textRef}
      style={props.width ? { maxWidth: `${props.width}px` } : undefined}
    >
      {props.value || "\u00A0"}
    </span>
  );

  return (
    <div className={styles.root}>
      <div className={styles.textContainer}>
        {!props.multiline && props.width ? (
          <Tooltip
            content={overflows ? props.value : undefined}
            className="max-w-xs text-wrap"
          >
            {span}
          </Tooltip>
        ) : (
          span
        )}
      </div>

      {props.multiline && (overflows || expanded) && (
        <div>
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              setExpanded(!expanded);
            }}
            className={styles.button}
          >
            {expanded ? "\u25B2" : "\u25BC"}
          </button>
        </div>
      )}
    </div>
  );
}
